import { z } from 'zod';

export const RECOVERY_DEVICE_PROOF_HEADER = 'x-playcast-recovery-proof';
export const recoveryDeviceProofSchema = z.object({
  nonce: z.string().regex(/^[a-f0-9]{64}$/),
  signature: z.string().min(1).max(256),
}).strict();
export type RecoveryDeviceRequest = 'poll' | 'ack';
export type RecoveryDeviceAcknowledgement = { directiveId: string; action: string };

/** Domain, machine, one-time challenge, route and acknowledgement are all signed. */
export function recoveryDevicePayload(machineId: string, nonce: string, request: RecoveryDeviceRequest,
  acknowledgement?: RecoveryDeviceAcknowledgement): string {
  return JSON.stringify(['playcast-platform-recovery:v1', machineId, nonce, request,
    acknowledgement?.directiveId ?? '', acknowledgement?.action ?? '']);
}
